//business logic:
export enum AggregationType {
    sum,
    average,
    averageWeighted,
}
export class AggregationMethod {
    public type: AggregationType;
    public columnIndex: number;    //weight by that column
}

//GUI-specific:
export enum UIAggregationType {
    sum,
    averageSomehow,
}
export class UIAggregationMethod {
    public type: UIAggregationType;
    public columnIndex: number | string;

    public static fromCore(method: AggregationMethod): UIAggregationMethod {
        const uiMethod = new UIAggregationMethod();
        
        if (method.type === AggregationType.sum) {
            uiMethod.type = UIAggregationType.sum;
            uiMethod.columnIndex = 'None';
        } else {
            uiMethod.type = UIAggregationType.averageSomehow;
            uiMethod.columnIndex = method.columnIndex;
        }
        
        return uiMethod;
    }

    public static toCore(uiMethod: UIAggregationMethod): AggregationMethod {
        const method = new AggregationMethod();
        
        if (uiMethod.type === UIAggregationType.sum) {
            method.type = AggregationType.sum;
            method.columnIndex = null;
        } else {
            if (Number.isInteger(uiMethod.columnIndex)) {
                method.type = AggregationType.averageWeighted;
                method.columnIndex = uiMethod.columnIndex as number;
            } else {
                method.type = AggregationType.average;
                method.columnIndex = null;
            }
        }
        
        return method;
    }
}